const problems = [
  {
    icon: 'ri-money-dollar-circle-line',
    text: 'Quotes can vary by thousands of dollars with no clear explanation',
  },
  {
    icon: 'ri-alert-line',
    text: 'Low bids often hide missing scope, cheaper materials, or shortcuts',
  },
  {
    icon: 'ri-thumb-down-line',
    text: "High bids don't guarantee better quality or workmanship",
  },
  {
    icon: 'ri-user-voice-line',
    text: 'Contractors use pressure tactics and confusing terminology',
  },
  {
    icon: 'ri-question-mark',
    text: "You're forced to make a major decision without clear, comparable data",
  },
];

export default function ProblemSection() {
  return (
    <section id="the-problem" className="bg-slate-50 py-24 border-t border-slate-100">
      <div className="max-w-4xl mx-auto px-6">

        {/* Headline block */}
        <div className="text-center mb-12">
          <p className="text-sm font-semibold tracking-widest text-orange-500 uppercase mb-4">
            The Hidden Risk
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
            Most Homeowners Get Roof Quotes Wrong
          </h2>
          <p className="text-lg text-gray-500 leading-relaxed max-w-2xl mx-auto">
            Getting multiple bids sounds smart — but without expert analysis, it&apos;s still a gamble.
          </p>
          <div className="w-16 h-1 bg-orange-400 rounded-full mx-auto mt-8"></div>
        </div>

        {/* Bullet list */}
        <div className="flex flex-col gap-4 mb-12">
          {problems.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-slate-200 px-6 py-5 flex items-start gap-4 hover:border-orange-200 hover:bg-orange-50/30 transition-colors cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 shrink-0 mt-0.5">
                <i className={`${item.icon} text-xl text-orange-500`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed font-medium">{item.text}</p>
            </div>
          ))}
        </div>

        {/* Closing paragraphs — always at the bottom */}
        <div className="flex flex-col gap-5">
          <div className="bg-white rounded-2xl border border-slate-200 px-7 py-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 shrink-0 mt-0.5">
                <i className="ri-user-smile-line text-xl text-orange-500"></i>
              </div>
              <p className="text-base text-gray-700 leading-relaxed">
                Most homeowners feel confident after getting a few quotes — until they later realize they{' '}
                <strong className="text-gray-900 font-semibold">overpaid or missed something important.</strong>
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 px-7 py-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 shrink-0 mt-0.5">
                <i className="ri-lightbulb-line text-xl text-orange-500"></i>
              </div>
              <p className="text-base text-gray-700 leading-relaxed">
                <strong className="text-gray-900 font-semibold">You shouldn&apos;t have to become a roofing expert</strong>{' '}
                to make the right decision. That&apos;s exactly why we exist.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
